import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ISectionHeaderProps } from '../components/section-header/section-header';
import { TextModel } from './text-model';
import { ITextProps } from '../components/text/text';
import { ButtonModel } from './button-model';
import { IButtonProps } from '../components/button/button';

export class SectionHeaderModel extends ContentItem {
  get header(): ITextProps[] {
    const items = get(this._config, 'elements.header.value', []);
    const modeledTexts = items.map((article: IText) =>
      TextModel.create(article as IText)
    );
    return modeledTexts;
  }

  get description(): ITextProps[] {
    const items = get(this._config, 'elements.description.value', []);
    const modeledTexts = items.map((article: IText) =>
      TextModel.create(article as IText)
    );
    return modeledTexts;
  }

  get button(): IButtonProps[] {
    const button = get(this._config, 'elements.button.value', []);
    const modeledButton = button.map((button: IButton) =>
      ButtonModel.create(button)
    );
    return modeledButton;
  }

  get buttonPosition(): string {
    const position = get(
      this._config,
      'elements.button_position.value[0].codename',
      ''
    );

    switch (position) {
      case 'left':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  }

  public static create(data: ISectionHeader): ISectionHeaderProps {
    const {
      header,
      description,
      button,
      buttonPosition
    } = new SectionHeaderModel(data);
    return {
      header,
      description,
      button,
      buttonPosition
    };
  }
}
